import React, { lazy } from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../components/pages/login";
import PageNotFound from "../components/pages/pageNotFound";
// import AppLayout from "../components/appLayout";
import { Outlet } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
import Dashboard from "../components/pages/dashboard";
// import { useEffect } from "react";
// import { message } from "antd";
import AppLayout from "../components/appLayout";
// import Meta from "../Meta";
// import { useState } from "react";
import RequireAuth from './requireAuth';

import LogsTable from "../components/pages/falcon/logs/LogsTable";
import ConnectForm from "../components/pages/projects/NewConnection/ConnectForm";


const Users = lazy(() => import("../components/pages/users"));
const Epms = lazy(() => import("../components/pages/epms"));
const AP_Prohance = lazy(() => import("../components/pages/ap_prohance"));
const AP_ProhanceCondition = lazy(() =>
  import("../components/pages/ap_prohancecondition")
);
const AP_ManageJobs = lazy(() => import("../components/pages/ap_manageJobs"));
const AP_Falcon = lazy(() => import("../components/pages/ap_falcon"));
const AP_FalconCondition = lazy(() =>
  import("../components/pages/ap_falconcondition")
);
const EpmsLogs = lazy(() => import("../components/pages/epmsLogs"));
const EpmsLogsDetail = lazy(() => import("../components/pages/epmsLogsDetail"));
const FalconLogs = lazy(() => import("../components/pages/falcon/logs"));

// Importing project components 
const ProjectOverview = lazy(() => import("../components/pages/projects/overview"))
const ProjectDetails = lazy(() => import("../components/pages/projects/details"))
const Jobs = lazy(() => import("../components/pages/projects/details/Jobs"))
const Connections = lazy(() => import("../components/pages/projects/details/Connections"))
const NewConnection = lazy(() => import("../components/pages/projects/NewConnection"));
const NewJob = lazy(() => import("../components/pages/projects/NewJobs"))
const CronJobDetails = lazy(() => import("../components/pages/projects/jobsDetail"))
const LogDetailsDrawer = lazy(() => import("../components/pages/projects/logDetails"))
const AP_MaestroAutoProvisioning = lazy(() => import("../components/pages/ap_maestro"));
const AP_MaestroCondition = lazy(() =>
  import("../components/pages/ap_maestro/conditions")
);
const ProtectedRoutes = () => {
  let user = localStorage.getItem("authToken");
  return user ? <Outlet /> : <Navigate replace to="login" />;
};

const PublicRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route
            path="/" element={<AppLayout />}>
            <Route path="/">
              <Route index={true} element={<Epms />} />
            </Route>
            <Route path="/employee-master">
              <Route element={<RequireAuth allowedRoles={["EMPLOYEE_MASTER_DASHBOARD1"]} />}>
                <Route
                  index={false}
                  path="dashboard"
                  element={<Dashboard />}
                ></Route>
              </Route>
              <Route element={<RequireAuth allowedRoles={["EMPLOYEE_MASTER_SNAPSHOT", "AD_MANAGER_SNAPSHOT"]} />}>
                <Route index={false} path="snapshot" element={<Epms />} />
              </Route>
              <Route element={<RequireAuth allowedRoles={["EMPLOYEE_MASTER_SNAPSHOT_LOGS", "AD_MANAGER_ACCESS_LOGS"]} />}>
                <Route index={false} path="logs" element={<EpmsLogs />} />
                <Route
                  index={false}
                  path="logsDetail"
                  element={<EpmsLogsDetail />}
                />
              </Route>
            </Route>
            <Route path="/auto-provisioning">
              <Route element={<RequireAuth allowedRoles={["AP_PROHANCE"]} />}>
                <Route
                  index={false}
                  path="prohance"
                  element={<AP_Prohance />}
                ></Route>
                <Route
                  index={false}
                  path="prohance/:id"
                  element={<AP_ProhanceCondition />}
                ></Route>
              </Route>
              <Route element={<RequireAuth allowedRoles={["AP_GLOBAL_JOB"]} />}>
                <Route
                  index={false}
                  path="manage-jobs"
                  element={<AP_ManageJobs />}
                ></Route>
              </Route>
              <Route element={<RequireAuth allowedRoles={["AP_PIXIE"]} />}>
                <Route index={false} path="falcon" element={<AP_Falcon />}></Route>
              </Route>
              <Route element={<RequireAuth allowedRoles={["AP_PIXIE"]} />}>
                <Route
                  index={false}
                  path="falcon/:id"
                  element={<AP_FalconCondition />}
                ></Route>
              </Route>
            </Route>

            <Route path="/maestro">
              <Route element={<RequireAuth allowedRoles={["AP_PROHANCE"]} />}>
                <Route
                  index={false}
                  path="auto-provisioning"
                  element={<AP_MaestroAutoProvisioning />}
                ></Route>
                <Route
                  index={false}
                  path="auto-provisioning/:id"
                  element={<AP_MaestroCondition />}
                ></Route>
              </Route>
            </Route>

            <Route path="/falcon">
              <Route element={<RequireAuth allowedRoles={["FALCON_LOGS"]} />}>
                <Route
                  index={false}
                  path="logs"
                  element={<FalconLogs />}
                ></Route>
                <Route
                  index={false}
                  path="logsDetails"
                  element={<LogsTable />}
                ></Route>
              </Route>
            </Route>

            {/* Added routes for projects tab */}
            <Route element={<RequireAuth allowedRoles={["AUTOMATION_PROJECT"]} />}>
              <Route path="/projects">
                <Route index={false} path="overview" element={<ProjectOverview />} >
                </Route>
                <Route path=":title" element={<ProjectDetails />} >
                </Route>
                <Route path=":title/:jobName/editJob" element={<NewJob />} />
                <Route path=":title/:jobName" element={<CronJobDetails />} />
                <Route path=":title/:jobName/:logDetails" element={<LogDetailsDrawer />} />
                <Route path=":title/addconnection" element={<NewConnection />} />
                <Route path="addconnection/:appName" element={<ConnectForm />} />
                <Route path=":title/addJob" element={<NewJob />} />
              </Route>
            </Route>



          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/unauthorized" element={<PageNotFound />} />
      </Routes>
    </>
  );
};
export default PublicRoutes;